import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Link } from "gatsby";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import Pagination from "./pagination";

const useStyles = makeStyles(theme => ({
  pagelist: {},
  count: {
    fontSize: "0.8125rem!important",
    fontStyle: "italic",
    textAlign: "center"
  },
  listItem: {
    transition: theme.transitions.create(["padding-left"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shortest
    }),
    "&:nth-child(even)": {
      backgroundColor: theme.app.tableHighlight
    },
    "&:hover": {
      paddingLeft: "24px",
      backgroundColor: "transparent"
    }
  },
  primaryText: { fontWeight: 500 },
  secondaryText: { fontSize: "0.8125rem!important", overflow: "hidden" }
}));

const PageList = ({
  pages,
  section,
  totalCount,
  numPages,
  currentPage,
  navigate
}) => {
  const classes = useStyles();
  const isManual = section === "manual";
  const isManualPos = section === "manualPos";
  const isReference = section === "reference";
  return (
    <div>
      <Pagination
        currentPage={currentPage}
        numPages={numPages}
        navigate={navigate}
        section={section}
      />
      <List className={classes.pagelist}>
        {pages.map(p => (
          <ListItem
            key={p.node.id}
            button
            component={Link}
            to={
              isManual
                ? `/manual/${p.node.slug}/`
                : isManualPos
                ? `/manual-pos/${p.node.slug}/`
                : isReference
                ? `/reference/${p.node.slug}/`
                : `/guide/${p.node.slug}/`
            }
            className={classes.listItem}
          >
            <ListItemText
              classes={{
                primary: classes.primaryText,
                secondary: classes.secondaryText
              }}
              primary={p.node.title}
              secondary={
                isManual
                  ? p.node.childContentfulManualTextTextNode.childMarkdownRemark
                      .excerpt
                  : isManualPos
                  ? p.node.childContentfulManualPosTextTextNode
                      .childMarkdownRemark.excerpt
                  : isReference
                  ? p.node.childContentfulReferenceContentTextNode
                      .childMarkdownRemark.excerpt
                  : p.node.childContentfulGuideContentTextNode
                      .childMarkdownRemark.excerpt
              }
            />
          </ListItem>
        ))}
      </List>
      <Typography className={classes.count}>{totalCount}st. totalt</Typography>
      <Pagination
        currentPage={currentPage}
        numPages={numPages}
        navigate={navigate}
        section={section}
      />
    </div>
  );
};

export default PageList;
